import ApiService from './ApiService'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: '/signin',
        method: 'post',
        data
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/create-account',
        method: 'post',
        data
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}

export async function apiGetDashboardData() {
    return ApiService.fetchData({
        url: '/users/get_dashboard_data',
        method: 'get',
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/email/forgot-password',
        method: 'post',
        data
    })
}


export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/email/reset-password',
        method: 'post',
        data
    })
}

export async function apiMobileForgotPassword(data) {
    return ApiService.fetchData({
        url: '/mobile/forgot-password',
        method: 'post',
        data
    })
}

export async function apiMobileResetPassword(data) {
    return ApiService.fetchData({
        url: '/mobile/reset-password',
        method: 'post',
        data
    })
}

export async function apiMobileVerify(data) {
    return ApiService.fetchData({
        url: '/verify_otp',
        method: 'post',
        data
    })
}

export async function apiMobileResendOTP() {
    return ApiService.fetchData({
        url: '/resend_otp',
        method: 'post',
    })
}
export async function apiResendVerificationEmail() {
    return ApiService.fetchData({
        url: '/resend-verify-email',
        method: 'get',
    });
}
export async function apiVerify({ url }) {
    return ApiService.fetchData({
        url,
        method: 'get'
    })
}

export async function apiGetDownline() {
    return ApiService.fetchData({
        url: '/users/get_downline',
        method: 'get',
    })
}